import { SectionsTreeNode } from '../types';

export const getTreeNodesByNodeIds = (tree: SectionsTreeNode[], targetIds: string[]): SectionsTreeNode[] => {
  const foundNodes: SectionsTreeNode[] = [];
  const idsToFind = new Set(targetIds);

  function traverse(nodes: SectionsTreeNode[]) {
    for (const node of nodes) {
      if (idsToFind.has(node.id)) {
        foundNodes.push(node);
        idsToFind.delete(node.id);
      }
      if (node.children && idsToFind.size > 0) {
        traverse(node.children);
      }
      if (idsToFind.size === 0) {
        return;
      }
    }
  }

  traverse(tree);
  return foundNodes;
};
